function getWishlist(){
 return JSON.parse(localStorage.getItem("wishlist")) || [];
}

function saveWishlist(list){
 localStorage.setItem("wishlist", JSON.stringify(list));
}

function toggleWishlist(handle,btn){

 let wishlist = getWishlist();

 const index = wishlist.indexOf(handle);

 if(index > -1){

   wishlist.splice(index,1);

 }else{

   /* prevent duplicate push */
   if(!wishlist.includes(handle)){
     wishlist.push(handle);
   }

 }

 saveWishlist(wishlist);

 updateWishlistCount();
 updateHeartIcons();
 if(btn){
   btn.classList.add("wishlist-bounce");
   setTimeout(()=> btn.classList.remove("wishlist-bounce"),400);
 }
 openWishlistDrawer();

 //loadWishlistDrawer();

}



function removeFromWishlist(handle, element){

 let wishlist = getWishlist();

 wishlist = wishlist.filter(p => p !== handle);

 saveWishlist(wishlist);

 let cache = getProductCache();
 delete cache[handle];
 saveProductCache(cache);

 updateWishlistCount();
 updateHeartIcons();

 element.style.transition="all .3s ease";
 element.style.opacity="0";
 element.style.transform="translateX(40px)";

 setTimeout(()=>{
   element.remove();
 },300);

}

function updateWishlistCount(){

 const wishlist = getWishlist();

 const badge = document.querySelector(".wishlist-count");

 if(!badge) return;

 badge.textContent = wishlist.length;

 badge.classList.add("wishlist-bounce");

 setTimeout(()=>{
   badge.classList.remove("wishlist-bounce");
 },400);

}

function updateHeartIcons(){

  const wishlist = getWishlist();

  document.querySelectorAll(".wishlist-btn").forEach(btn => {

    const handle = btn.getAttribute("data-handle");
    const heart = btn.querySelector(".wishlist-heart");

    if(!heart) return;

    if(wishlist.includes(handle)){
      btn.classList.add("saved");
      heart.innerHTML = "♥";
    }else{
      btn.classList.remove("saved");
      heart.innerHTML = "♡";
    }

  });

}

async function loadWishlistPage(){

 const container = document.getElementById("wishlist-products");
 if(!container) return;

 const wishlist = getWishlist();
 const cache = getProductCache();

 if(!wishlist.length){
   container.innerHTML = "<p>Your wishlist is empty.</p>";
   return;
 }

 let html = "";

 for(const handle of wishlist){

   let product = cache[handle];

   if(!product){

     const res = await fetch(`/products/${handle}.js`);
     const data = await res.json();

     product = {
       handle:data.handle,
       title:data.title,
       price:data.price,
       image:data.images[0]
     };

     cache[handle] = product;

   }

   html += `
<div class="wishlist-card product-card-wrapper" style="margin-bottom: 20px;">
  <div class="card__inner" style="position: relative; overflow: hidden; border-radius: 4px 4px 0 0;">
    <a href="/products/${product.handle}" style="display: block;">
      <img src="${product.image}" alt="${product.title}" style="width: 100%; display: block; transition: transform 0.5s ease;" />
    </a>
  </div>

  <div class="card__content" style="padding: 15px; text-align: center; background: #fff;">
    <h3 class="card__heading" style="margin: 0 0 8px 0 !important;">
      <a href="/products/${product.handle}" style="text-decoration: none; color: #1a1a1a; transition: color 0.3s ease;">
        ${product.title}
      </a>
    </h3>

    <div class="price-container">
      <span style="font-family: 'Montserrat', sans-serif; font-weight: 700; color: #D4AF37; font-size: 15px; letter-spacing: 0.5px;">
        ₹${(product.price / 100).toLocaleString('en-IN')}
      </span>
    </div>
  </div>
</div>
`;


 }

 container.innerHTML = html;

 saveProductCache(cache);

}

function getProductCache(){
 return JSON.parse(localStorage.getItem("wishlistProducts")) || {};
}

function saveProductCache(cache){
 localStorage.setItem("wishlistProducts", JSON.stringify(cache));
}


async function loadWishlistDrawer(){

 const container = document.getElementById("wishlist-drawer-items");
 if(!container) return;

 container.innerHTML = "";

 const wishlist = getWishlist();
 const cache = getProductCache();

 if(!wishlist.length){
   container.innerHTML = "<p style='padding:20px'>No saved sarees yet.</p>";
   return;
 }

 let index = 0;

 for(const handle of wishlist){

   let product = cache[handle];

   /* fetch only if not cached */
   if(!product){

     try{

       const res = await fetch(`/products/${handle}.js`);
       const data = await res.json();

       product = {
         handle:data.handle,
         title:data.title,
         price:data.price,
         image:data.images[0]
       };

       cache[handle] = product;

     }catch(err){
       console.error("Wishlist fetch error:", err);
       continue;
     }

   }

   const html = `
   <div class="wishlist-drawer-item" data-handle="${product.handle}">
     <img src="${product.image}">
     <div class="wishlist-drawer-info">
       <p>${product.title}</p>
       <p>₹${product.price/100}</p>
     </div>
     <button class="wishlist-remove" data-handle="${product.handle}">✕</button>
   </div>
   <div class="wishlist-divider"></div>
   `;

   container.insertAdjacentHTML("beforeend", html);

   const item = container.lastElementChild;
   item.style.animationDelay = (index * 0.05) + "s";

   index++;

 }

 saveProductCache(cache);

}

/*async function loadWishlistDrawer11(){

const container = document.getElementById("wishlist-drawer-items");
if(!container) return;

container.innerHTML = "";

const wishlist = getWishlist();
if(!wishlist.length){
 container.innerHTML = "<p style='padding:20px'>No saved sarees yet.</p>";
 return;
}
const cache = getProductCache();

let html = "";

for(const handle of wishlist){

let product = cache[handle];

if(product){

 html += `
 <div class="wishlist-drawer-item" data-handle="${product.handle}">
   <img src="${product.image}">
   <div class="wishlist-drawer-info">
     <p>${product.title}</p>
     <p>₹${product.price/100}</p>
   </div>
   <button class="wishlist-remove" data-handle="${product.handle}">✕</button>
 </div>
 `;

 continue;

}

try{

 const res = await fetch(`/products/${handle}.js`);
 const data = await res.json();

 product = {
   handle:data.handle,
   title:data.title,
   price:data.price,
   image:data.images[0]
 };

 cache[handle] = product;

 html += `
 <div class="wishlist-drawer-item" data-handle="${product.handle}">
   <img src="${product.image}">
   <div class="wishlist-drawer-info">
     <p>${product.title}</p>
     <p>₹${product.price/100}</p>
   </div>
   <button class="wishlist-remove" data-handle="${product.handle}">✕</button>
 </div>
 `;

}catch(err){
console.error("Wishlist fetch error", err);
}

}

container.innerHTML = html;

saveProductCache(cache);

} */

function openWishlistDrawer(){

 document.getElementById("wishlist-drawer").classList.add("open");
 document.getElementById("wishlist-overlay").classList.add("active");

 document.body.style.overflow="hidden";

 loadWishlistDrawer();

}

function closeWishlistDrawer(){

 document.getElementById("wishlist-drawer").classList.remove("open");
 document.getElementById("wishlist-overlay").classList.remove("active");

 document.body.style.overflow="";

}

document.addEventListener("DOMContentLoaded", function(){

  updateWishlistCount();
  loadWishlistPage();

  /* run once */
  updateHeartIcons();

  /* run again after cards render */
  setTimeout(updateHeartIcons, 200);

   /* overlay click close */
  const overlay = document.getElementById("wishlist-overlay");
  if(overlay){
    overlay.addEventListener("click", closeWishlistDrawer);
  }

});


let wishlistClickLock = false;

document.addEventListener("click", function(e){

 const wishlistBtn = e.target.closest(".wishlist-btn");

 if(!wishlistBtn || wishlistClickLock) return;

 wishlistClickLock = true;

 setTimeout(()=>{
   wishlistClickLock = false;
 },200);

 e.preventDefault();
 e.stopPropagation();

 const handle = wishlistBtn.getAttribute("data-handle");

 toggleWishlist(handle, wishlistBtn);

});

document.addEventListener("click", function(e){

  const removeBtn = e.target.closest(".wishlist-remove");

  if(!removeBtn) return;

  const handle = removeBtn.getAttribute("data-handle");
  const item = removeBtn.closest(".wishlist-drawer-item");

  removeFromWishlist(handle, item);

});

document.addEventListener("click", function(e){

  const overlay = e.target.closest("#wishlist-overlay");

  if(!overlay) return;

  closeWishlistDrawer();

});



//document.getElementById("wishlist-overlay").onclick = closeWishlistDrawer;

document.querySelector(".wishlist-close-btn")
  .addEventListener("click", closeWishlistDrawer);










  document.addEventListener("DOMContentLoaded", function(){

  const modal = document.getElementById("sp-image-modal");
  const modalImg = document.getElementById("sp-modal-img");
  const loader = document.getElementById("sp-global-loader-wrapper");
  const spinner = document.getElementById("sp-global-spinner");
  const content = document.querySelector(".sp-modal-content");

  document.addEventListener("click", function(e){

    const btn = e.target.closest(".sp-zoom-btn");

    if(btn){
  const imgSrc = btn.getAttribute("data-image");

  modalImg.classList.remove("loaded");
  modalImg.src = "";

  // 🔥 SHOW BOTH
  loader.classList.add("active");
  spinner.classList.add("active");

  modal.classList.add("active");

  const img = new Image();
  img.src = imgSrc;

  /*setTimeout(() => {
  modalImg.src = imgSrc;
  modalImg.classList.add("loaded");
  loader.classList.remove("active");
    spinner.classList.remove("active");
}, 1500);*/

  img.onload = function(){
    modalImg.src = imgSrc;
    modalImg.classList.add("loaded");

    // 🔥 HIDE BOTH
    loader.classList.remove("active");
    spinner.classList.remove("active");

    // 🔥 WAIT FOR IMAGE TO RENDER
  setTimeout(() => {
    initTouchZoom();
    resetZoomState();
  }, 100);
  };

  return;
}

    if(e.target.classList.contains("sp-modal-close")){
      modal.classList.remove("active");
      return;
    }

    if(modal.classList.contains("active") && !content.contains(e.target)){
      modal.classList.remove("active");
    }

  });

  document.addEventListener("keydown", function(e){
    if(e.key === "Escape"){
      modal.classList.remove("active");
    }
  });

});

function resetZoomState() {
  scale = 1;
  posX = 0;
  posY = 0;
zoomImg = document.getElementById("sp-modal-img");
  zoomImg.style.transform = "scale(1) translate(0,0)";
}

function initTouchZoom() {

  const zoomImg = document.getElementById("sp-modal-img");
  if (!zoomImg) return;

  let lastTouchX = 0;
  let lastTouchY = 0;
  let initialDistance = 0;

  let scale = 1;
  let minScale = 1;
  let maxScale = 3;

  let posX = 0;
  let posY = 0;

  function updateTransform() {
    zoomImg.style.transform =
      `scale(${scale}) translate(${posX}px, ${posY}px)`;
  }

  function getDistance(touches) {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }



  // 🔥 TOUCH START
  zoomImg.addEventListener("touchstart", function(e){

    if (e.touches.length === 1) {
      lastTouchX = e.touches[0].clientX;
      lastTouchY = e.touches[0].clientY;
    }

    if (e.touches.length === 2) {
      initialDistance = getDistance(e.touches);
    }

  }, { passive: true });

  // 🔥 TOUCH MOVE
  zoomImg.addEventListener("touchmove", function(e){

   // console.log("TOUCH MOVE WORKING");

    // PINCH ZOOM
    if (e.touches.length === 2) {
      e.preventDefault();

      const newDistance = getDistance(e.touches);
      const scaleChange = newDistance / initialDistance;

      scale *= scaleChange;
      scale = Math.max(minScale, Math.min(maxScale, scale));

      initialDistance = newDistance;

      updateTransform();
    }

    // DRAG
    if (e.touches.length === 1 && scale > 1) {
      e.preventDefault();

      const touch = e.touches[0];

      const dx = touch.clientX - lastTouchX;
      const dy = touch.clientY - lastTouchY;

      posX += dx;
      posY += dy;

      lastTouchX = touch.clientX;
      lastTouchY = touch.clientY;

      updateTransform();
    }

  }, { passive: false });

}



  
document.addEventListener("DOMContentLoaded", function(){

  const zoomImg = document.getElementById("sp-modal-img");
  if (!zoomImg) return;

  let scale = 1;
  let minScale = 1;
  let maxScale = 3;

  let isZoomed = false;
  let isDragging = false;
  let hasMoved = false;

  let startX, startY;
  let posX = 0, posY = 0;

  function updateTransform() {
    clampPosition();

    zoomImg.style.transform =
      `scale(${scale}) translate(${posX}px, ${posY}px)`;
  }

function clampPosition() {

  const container = zoomImg.parentElement;
  const containerRect = container.getBoundingClientRect();

  const scaledWidth = containerRect.width * scale;
  const scaledHeight = containerRect.height * scale;

  const maxX = (scaledWidth - containerRect.width) / 2;
  const maxY = (scaledHeight - containerRect.height) / 2;

  posX = Math.max(-maxX, Math.min(maxX, posX));
  posY = Math.max(-maxY, Math.min(maxY, posY));
}
  

  zoomImg.addEventListener("touchmove", function(e){

  if (e.touches.length === 2) {
    e.preventDefault(); // 🔥 MUST

    const newDistance = getDistance(e.touches);
    const scaleChange = newDistance / initialDistance;

    scale *= scaleChange;
    scale = Math.max(minScale, Math.min(maxScale, scale));

    initialDistance = newDistance;

    updateTransform();
  }

  if (e.touches.length === 1 && isZoomed) {
    e.preventDefault(); // 🔥 MUST

    const touch = e.touches[0];

    const dx = touch.clientX - lastTouchX;
    const dy = touch.clientY - lastTouchY;

    posX += dx;
    posY += dy;

    lastTouchX = touch.clientX;
    lastTouchY = touch.clientY;

    updateTransform();
  }

}, { passive: false }); // 🔥 THIS LINE IS CRITICAL


zoomImg.addEventListener("touchstart", function(e){

  if (e.touches.length === 1) {
    lastTouchX = e.touches[0].clientX;
    lastTouchY = e.touches[0].clientY;
  }

  if (e.touches.length === 2) {
    initialDistance = getDistance(e.touches);
  }

}, { passive: true });

  // 🟢 HOVER PAN
  zoomImg.addEventListener("mousemove", function(e){
    if (isDragging || !isZoomed) return;

    const rect = zoomImg.getBoundingClientRect();

    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;

    posX = (0.5 - x) * 200;
    posY = (0.5 - y) * 200;

    updateTransform();
  });

  // 🟢 SCROLL ZOOM (CURSOR FOCUSED)
  zoomImg.addEventListener("wheel", function(e){
    e.preventDefault();

    const rect = zoomImg.getBoundingClientRect();

    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    const zoomSpeed = 0.2;
    let newScale = scale;

    if (e.deltaY < 0) newScale += zoomSpeed;
    else newScale -= zoomSpeed;

    newScale = Math.max(minScale, Math.min(maxScale, newScale));

    const scaleRatio = newScale / scale;

    posX = (posX - mouseX) * scaleRatio + mouseX;
    posY = (posY - mouseY) * scaleRatio + mouseY;

    scale = newScale;

    updateTransform();
  });

  // 🟢 MOUSEDOWN
  zoomImg.addEventListener("mousedown", function(e){
    hasMoved = false;
    isDragging = true;

    startX = e.clientX;
    startY = e.clientY;
  });

  // 🟢 MOUSEMOVE (DRAG)
  window.addEventListener("mousemove", function(e){

    if (!isDragging || !isZoomed) return;

    const dx = e.clientX - startX;
    const dy = e.clientY - startY;

    if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
      hasMoved = true;
    }

    posX += dx;
    posY += dy;

    startX = e.clientX;
    startY = e.clientY;

    zoomImg.style.cursor = "grabbing";

    updateTransform();
  });

  // 🟢 MOUSEUP (CLICK + DRAG CONTROL)
  window.addEventListener("mouseup", function(e){

    if (!isDragging) return;

    isDragging = false;

    // 👉 CLICK (no movement)
    if (!hasMoved) {
      const rect = zoomImg.getBoundingClientRect();

      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      isZoomed = !isZoomed;

      if (isZoomed) {
        scale = 2;
        posX = (rect.width / 2 - x);
        posY = (rect.height / 2 - y);
        zoomImg.style.cursor = "grab";
      } else {
        scale = 1;
        posX = 0;
        posY = 0;
        zoomImg.style.cursor = "zoom-in";
      }

      updateTransform();
    } else {
      zoomImg.style.cursor = "grab";
    }
  });

});





document.querySelectorAll(".sp-add-to-cart-btn").forEach(btn => {

  btn.addEventListener("click", async function(){

    const variantId = this.dataset.variantId;


     // 🚫 BLOCK if already loading
  if (this.classList.contains("loading")) return;

       // 🟢 IF ALREADY ADDED → OPEN DRAWER ONLY
    const drawer = document.querySelector('cart-drawer');
    if (this.classList.contains("added")) {
      if (drawer && drawer.open) drawer.open();
      return;
    }

    try {
       // 🟢 SHOW LOADER
      this.classList.add("loading");
      // 🟢 add to cart
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      // 🟢 fetch updated drawer
      const res = await fetch('/?sections=cart-drawer');
      const data = await res.json();

      const drawer = document.querySelector('cart-drawer');

      if (drawer) {

        const parser = new DOMParser();
        const newDoc = parser.parseFromString(data['cart-drawer'], 'text/html');

        const newContent = newDoc.querySelector('cart-drawer').innerHTML;

        drawer.innerHTML = newContent;

        // 🟢 UPDATE STATE
         this.classList.remove("loading");
        this.classList.add("added");

        // 🟢 NOW OPEN
        drawer.open();
      }

    } catch (err) {
      console.error(err);
    }

  });

});


async function syncCartState() {

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const cartItems = cart.items.map(item => item.id);

    document.querySelectorAll(".sp-add-to-cart-btn").forEach(btn => {
      const variantId = parseInt(btn.dataset.variantId);

      if (cartItems.includes(variantId)) {
        btn.classList.add("added");
      } else {
        btn.classList.remove("added");
      }
    });

  } catch (err) {
    console.error("Cart sync failed", err);
  }
}

// 🔥 run on load
document.addEventListener("DOMContentLoaded", syncCartState);


const originalFetch = window.fetch;

window.fetch = async function(...args) {

  const response = await originalFetch(...args);

  // detect cart update calls
  if (args[0].includes('/cart/change') || args[0].includes('/cart/update')) {
    setTimeout(syncCartState, 300);
  }

  return response;
};

document.addEventListener('DOMContentLoaded', function () {

  const buyNowBtn = document.querySelector('.sticky-buy-now');
  if (!buyNowBtn) return;

   const addToCartBtn = document.querySelector('.sticky-atc-btn');
  

    buyNowBtn.addEventListener('click', function () {


    sessionStorage.setItem('checkoutSource', 'buy_now');

    const productHandle = window.location.pathname;

    sessionStorage.setItem('wentToCheckout', 'true');
    sessionStorage.setItem('checkoutProduct', productHandle);

    sessionStorage.removeItem('assistShown'); // reset for fresh session

    document.querySelector('.sticky-atc-btn')?.classList.add('disabled');
    // show loading state
    buyNowBtn.innerText = "Secure checkout...";
    buyNowBtn.classList.add('btn-loading');

        // 🔥 disable Add to Cart
    if (addToCartBtn) {
      addToCartBtn.classList.add('disabled');
      addToCartBtn.disabled = true;
    }

    // trigger Shopify dynamic checkout
    const originalBtn = document.querySelector('.shopify-payment-button__button');
    if (originalBtn) {
      originalBtn.click();
    }
  });
});

// ADD TO CART (REFACTORED + OPTIMIZED)
document.addEventListener('DOMContentLoaded', function () {

  const stickyAtc = document.querySelector('.sticky-atc-btn');
    if (!stickyAtc) return;

  const stickyBuy = document.querySelector('.sticky-buy-now');
  const cartDrawer = document.querySelector('cart-drawer');



  let isSubmitting = false;

  // 🔹 CLICK HANDLER
  stickyAtc.addEventListener('click', async function () {

      clearAssistState(); // 🔥 ADD THIS LINE

    if (isSubmitting) return;
    isSubmitting = true;

    const variantId = document.querySelector('input[name="id"]')?.value;

    disableBuyNow();
    setLoading();

    try {
      const cart = await fetchCart();

      const alreadyInCart = cart.items.some(item => item.id == variantId);

      if (alreadyInCart) {
        openDrawer();
        showSuccess(); // same UX for consistency
        stickyAtc.innerText = "Already in cart";
        return;
      }

      triggerOriginalATC(); // Shopify handles flow

    } catch (err) {
      console.error('Cart error:', err);
      resetState();
    }
  });

  // 🔹 OBSERVER (Shopify success detection)
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      const isOpen = isDrawerOpen();

    // 🔥 HANDLE STICKY VISIBILITY
    if (isOpen) {
      document.body.classList.add('cart-open');
    } else {
      document.body.classList.remove('cart-open');
    }

    // existing success logic
    if (isOpen) {
      if (!stickyAtc.classList.contains('loading')) return;
      showSuccess();
    }
    });

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class', 'open'],
    });
  }

function handleDrawerCloseCheck() {
  setTimeout(() => {
    const drawer = document.querySelector('cart-drawer');

    if (drawer && !drawer.classList.contains('active')) {
      document.body.classList.remove('cart-open');
    }
  }, 300);
}

document.addEventListener('click', handleDrawerCloseCheck);
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    handleDrawerCloseCheck();
  }
});

  // =========================
  // 🔥 FUNCTIONS (CLEAN LAYER)
  // =========================

  function fetchCart() {
    return fetch('/cart.js').then(res => res.json());
  }

  function triggerOriginalATC() {
    const btn = document.querySelector('.product-form__submit');
    if (btn) btn.click();
  }

  function openDrawer() {
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }

  function isDrawerOpen() {
    return cartDrawer.classList.contains('active') || cartDrawer.open;
  }

  function disableBuyNow() {
    if (stickyBuy) {
      stickyBuy.classList.add('disabled');
      stickyBuy.disabled = true;
    }
  }

  function enableBuyNow() {
    if (stickyBuy) {
      stickyBuy.classList.remove('disabled');
      stickyBuy.disabled = false;
    }
  }

  function setLoading() {
    stickyAtc.innerText = "Adding...";
    stickyAtc.classList.add('loading');
  }

  function showSuccess() {
    stickyAtc.innerText = "✓ Added";
    stickyAtc.classList.remove('loading');
    stickyAtc.classList.add('success');

    enableBuyNow();

    setTimeout(resetState, 1200);
  }

  function resetState() {
    stickyAtc.innerText = "ADD TO CART";
    stickyAtc.classList.remove('loading', 'success');
    enableBuyNow();
    isSubmitting = false;
  }
});




document.addEventListener('DOMContentLoaded', function () {

  if (!/^\/products\//.test(window.location.pathname)) return;

  const stickyContainer = document.querySelector('.sticky-atc');
  if (!stickyContainer) return;

 // 🔥 NEW: detect back from checkout
  const cameFromCheckout = document.referrer.includes('/checkout');
  if (cameFromCheckout) {
    sessionStorage.setItem('wentToCheckout', 'true');
  }

  const wentToCheckout = sessionStorage.getItem('wentToCheckout');
  const assistShown = sessionStorage.getItem('assistShown');
  const currentProduct = window.location.pathname;
  const checkoutProduct = sessionStorage.getItem('checkoutProduct');

  // 🎯 CONDITION: only once after checkout return
  if (wentToCheckout && !assistShown &&
  checkoutProduct === currentProduct) {
   // showAssistMode();
    showAssistUI();

    sessionStorage.setItem('assistShown', 'true');

    // ⏳ auto clear after 5 mins
    setTimeout(() => {
      sessionStorage.removeItem('wentToCheckout');
    }, 5 * 60 * 1000);
  }


function showAssistUI() {
  const source = sessionStorage.getItem('checkoutSource');

  let headingText = "Need help?";

  if (source === 'buy_now') {
    headingText = "Almost yours — need help completing checkout?";
  } else if (source === 'cart') {
    headingText = "Confused? We’ll help you pick the right saree";
  }

  document.querySelector('.sticky-default')?.style.setProperty('display', 'none');
  document.querySelector('.sticky-assist')?.style.setProperty('display', 'block');

  const heading = document.getElementById('assist-heading');
  if (heading) heading.innerText = headingText;

  // store price once
  const originalPrice = document.querySelector('.sticky-price')?.innerText;
  if (originalPrice) {
    sessionStorage.setItem('lastPrice', originalPrice);
  }
}

function showDefaultUI() {
  document.querySelector('.sticky-default')?.style.setProperty('display', 'block');
  document.querySelector('.sticky-assist')?.style.setProperty('display', 'none');
}

  function restoreStickyUI() {
  location.reload(); 
}

  function clearAssistState() {
    sessionStorage.removeItem('wentToCheckout');
    sessionStorage.removeItem('assistShown');
  }
});


function clearAssistState() {
  sessionStorage.removeItem('wentToCheckout');
  sessionStorage.removeItem('assistShown');
  sessionStorage.removeItem('checkoutProduct');
}


document.addEventListener('click', function (e) {
  const checkoutBtn = e.target.closest('[name="checkout"], a[href="/checkout"]');

  if (checkoutBtn) {
    sessionStorage.setItem('checkoutSource', 'cart');
    const productHandle = window.location.pathname;
    sessionStorage.setItem('wentToCheckout', 'true');
    sessionStorage.setItem('checkoutProduct', productHandle);
    sessionStorage.removeItem('assistShown');
  }
});

window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    const wentToCheckout = sessionStorage.getItem('wentToCheckout');

    if (!wentToCheckout) {
      showDefaultUI(); // 👈 SAFE FIX
    }
  }
});


document.addEventListener('DOMContentLoaded', function () {

  const whatsappBtn = document.querySelector('.sticky-whatsapp');
  const continueBtn = document.querySelector('.sticky-continue');

  // 📲 WhatsApp CTA
  if (whatsappBtn) {
    whatsappBtn.addEventListener('click', function () {
      const productName = document.querySelector('h1')?.innerText || "this saree";
      const price = sessionStorage.getItem('lastPrice') || "";

      const message = `Hi, I was checking ${productName} ${price}. Can you help me with details?`;
      const url = `https://wa.me/919059869444?text=${encodeURIComponent(message)}`;

      window.open(url, '_blank');

      clearAssistState();
      showDefaultUI(); // 👈 IMPORTANT
    });
  }

  // 🔁 Continue checkout
  if (continueBtn) {
    continueBtn.addEventListener('click', function () {

        // 🔥 SAME SPINNER CLASS
  continueBtn.classList.add('btn-loading');
  continueBtn.innerText = "Secure checkout...";

  continueBtn.disabled = true;

      const originalBtn = document.querySelector('.shopify-payment-button__button');
      if (originalBtn) originalBtn.click();

      clearAssistState();
    });
  }

  function showDefaultUI() {
  document.querySelector('.sticky-default')?.style.setProperty('display', 'block');
  document.querySelector('.sticky-assist')?.style.setProperty('display', 'none');
}

});